export default __webpack_public_path__ + "static/media/logo_juego_responsable_43.aca20811.png";